import { render, staticRenderFns } from "./noticeReply.vue?vue&type=template&id=61361948&scoped=true&"
import script from "./noticeReply.vue?vue&type=script&lang=ts&"
export * from "./noticeReply.vue?vue&type=script&lang=ts&"
import style0 from "./noticeReply.vue?vue&type=style&index=0&id=61361948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61361948",
  null
  
)

export default component.exports